<template lang="pug">
div
  .row(style='margin-top: 32px; margin-bottom: 32px')
    .col-12
      .switch
        label.switch-light
          input(
            @click='$emit("togglePlan")'
            checked
            type='checkbox'
          )
          span 
            span.text.mensal {{ $t('pages.billing.myPlans.monthly') }}
            span.text.anual {{ $t('pages.billing.myPlans.annual') }}
          a.btn.btn-switch-selected
          .discount {{ $t('pages.billing.myPlans.discount') }}
  .row
    .col-12.col-sm-6.col-lg-3(
      :key='plan.id'
      v-for='plan in plans'
      v-if='showAnnuallyOrMonthly(plan)'
    )
      .card.card--plans(:class='getCardPlanStyle(plan.label)')
        .card-header 
          .card-tag.d-flex.flex-row-reverse
            .tag(
              :style='plan.label === "essential" ? "background-color: #FFB731" : ""'
            )
              icon(:name='plan.tag.icon')
              span.text {{ plan.tag.name }}
            .tag(
              style='margin-right: 0.313rem'
              v-if='isTheActivePlan(plan.id)'
            )
              icon(name='circle-check')
              span.text {{ $t('pages.billing.myPlans.active') }}
          .card-title
            icon(:name='plan.title.icon')
            span.text {{ plan.title.name }}
          .card-prices
            div(v-if='plan.price && lackPlan === "12"')
              .price-year
                span.money-cipher {{ plan.currency_symbol }}
                span.money-number {{ plan.price.annual.annual.number }}
                span.money-cents {{ plan.price.annual.annual.cents }}
              .price-month
                span.money-cipher {{ plan.currency_symbol }}
                span.money-number {{ plan.price.annual.monthly.number }}
                span.money-cents {{ plan.price.annual.monthly.cents }}
            div(v-else-if='plan.price && lackPlan === "1"')
              .price-year
                span.money-cipher {{ plan.currency_symbol }}
                span.money-number {{ plan.price.monthly.number }}
                span.money-cents {{ plan.price.monthly.cents }}
            div(v-else)
              .text(
                style='font-weight: 600; font-size: 24px; margin-top: 1.5rem; color: #202020'
              ) {{ $t('pages.billing.myPlans.custom') }}
          hr
          .card-description
            .text {{ getPlanDescription(plan) }}
        .card-body
          ul.list-unstyled 
            li(:key='benefit' v-for='benefit in plan.benefits')
              icon(name='circle-check')
              span.text {{ benefit }}
        .card-footer(v-if='!isTheActivePlan(plan.id)')
          button.btn.btn-primary(@click='submit(plan.id)' type='button') {{ getNameButton(plan.title.name) }}
  PlanComparison(@startPlan='startPlan')
  payment-document-modal(@confirm='signPlan' ref='paymentDocumentModal')
  payment-in-progressModal(ref='paymentInProgressModal')
  HubSpotModal(
    :form-id='hubSpotFormId'
    :portal-id='hubSpotPortalId'
    ref='hubSpotModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import BillingHttp from '@/services/BillingHttp';
import PlanComparison from './PlanComparison.vue';
import PaymentDocumentModal from '@/modules/account/components/organisms/modals/PaymentDocumentModal.vue';
import PaymentInProgressModal from '@/modules/account/components/organisms/modals/PaymentInProgressModal.vue';
import HubSpotModal from '@/modules/account/components/organisms/modals/HubSpotModal.vue';
import alert from '@/modules/account/common/alert';
import config from '@/config';

export default {
  name: 'MyPlans',
  components: {
    Icon,
    PlanComparison,
    PaymentDocumentModal,
    PaymentInProgressModal,
    HubSpotModal,
  },
  data() {
    return {
      selectedPlan: null,
      isFormLoaded: false,
      lastInvoiceDocument: null,
      hubSpotPortalId: config.hubSpotPortalId,
    };
  },
  props: {
    plans: Array,
    lackPlan: String,
  },
  computed: {
    hubSpotFormId() {
      switch (this.$i18n.locale) {
        case 'pt-BR':
          return config.hubSpotFormId.ptBr;
        case 'en':
          return config.hubSpotFormId.us;
        case 'es':
          return config.hubSpotFormId.es;
        default:
          return config.hubSpotFormId.ptBr;
      }
    },
  },
  methods: {
    getNameButton(planName) {
      return planName === 'Corporativo'
        ? this.$t('pages.billing.myPlans.consultant')
        : this.$t('pages.billing.myPlans.choosePlan');
    },
    getCardPlanStyle(planLabel) {
      const styles = {
        advanced: 'card--plans--complete',
        corporate: 'card--plans--corporate',
        essential: 'card--plans--essential',
      };
      return styles[planLabel] || '';
    },
    showAnnuallyOrMonthly(plan) {
      if (plan.interval == this.lackPlan || plan.label == 'corporate') {
        return true;
      }
      return false;
    },
    isTheActivePlan(id) {
      if (
        id === this.$store.state.subscription.plan.plan.id &&
        this.$store.state.subscription.plan.state !== 'cancelled'
      ) {
        return true;
      }
      return false;
    },
    startPlan(planName) {
      this.selectedPlan = this.plans.find(
        (plan) => plan.title.name === planName && plan.interval == this.lackPlan
      );
      this.submit(this.selectedPlan?.id ?? undefined);
    },
    submit(id) {
      this.selectedPlan = id;
      if (!this.selectedPlan || this.$root.isUSAVersion) {
        this.signPlan();
        return;
      }
      this.openDocumentModal();
    },
    async openDocumentModal() {
      const invoiceDocument = await this.getLastInvoiceDocument();
      this.$refs.paymentDocumentModal.open(
        invoiceDocument || this.$root.user.cpf
      );
    },
    async getLastInvoiceDocument() {
      if (this.lastInvoiceDocument !== null) {
        return this.lastInvoiceDocument;
      }
      try {
        this.$loading(true);
        const invoices = await BillingHttp.getInvoices('page=1');
        const lastInvoice = invoices.data?.data?.[0];
        this.lastInvoiceDocument = lastInvoice?.document_number || '';
      } catch (error) {
        this.lastInvoiceDocument = '';
      } finally {
        this.$loading(false);
      }
      return this.lastInvoiceDocument;
    },
    async signPlan(documentNumber) {
      this.$loading(true);
      try {
        if (!this.selectedPlan) {
          this.loadHubSpotForm();
          return;
        }
        const payload = { plan: this.selectedPlan };
        if (documentNumber && !this.$root.isUSAVersion) {
          payload.document_number = documentNumber;
        }
        const invoice = await BillingHttp.signPlan(payload);
        const responseUrl = new URL(this.$route.path, window.location.origin)
          .href;
        window.location.href = `${invoice.data.checkout_url}&callBackResponseUrl=${responseUrl}?token=`;
      } catch (error) {
        this.$loading(false);
        if (error.response?.status === 412) {
          this.$refs.paymentInProgressModal.$refs.modal.open();
          return;
        }
        alert.fireAlert(this.$t('modal.paymentDocument.errorMessage'), {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
      }
    },
    loadHubSpotForm() {
      this.$refs.hubSpotModal.$refs.modal.open();
      this.$loading(false);
    },
    getPlanDescription(plan) {
      switch (plan.label) {
        case 'basic':
          return this.$t('pages.planComparison.basic.description');
        case 'advanced':
          return this.$t('pages.planComparison.advanced.description');
        case 'essential':
          return this.$t('pages.planComparison.essential.description');
        case 'corporate':
          return this.$t('pages.planComparison.corporate.description');
        case 'free':
          return this.$t('pages.planComparison.free.description');
        default:
          return plan.description;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.discount
  font-size: 0.75rem
</style>
